const cssUnit = {
  cm: true,
  mm: true,
  in: true,
  px: true,
  pt: true,
  pc: true,
  em: true,
  ex: true,
  ch: true,
  rem: true,
  vw: true,
  vh: true,
  vmin: true,
  vmax: true,
  "%": true,
}
export function parseLengthAndUnit(size: any) {
  if (typeof size === "number") {
    return {
      value: size,
      unit: "px",
    }
  }
  let value
  const valueString = (size.match(/^[0-9.]*/) || "").toString()
  if (valueString.includes(".")) {
    value = parseFloat(valueString)
  } else {
    value = parseInt(valueString, 10)
  }
  const unit = (size.match(/[^0-9]*$/) || "").toString()
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  if (cssUnit[unit]) {
    return {
      value,
      unit,
    }
  }
  console.warn(
    `React Spinners: ${size} is not a valid css value. Defaulting to ${value}px.`
  )
  return {
    value,
    unit: "px",
  }
}
export function cssValue(value: any) {
  const lengthWithunit = parseLengthAndUnit(value)
  return `${lengthWithunit.value}${lengthWithunit.unit}`
}
